import { gql } from '@apollo/client'

export const CHART3_RESULT_QUERY = gql`
  query processingsClosedCountByProcessingTypeResult(
    $categoryName: String!
    $filter: ProcessingsClosedCountByProcessingTypeResultFilter
    $groupBy: ProcessingsClosedCountByProcessingTypesGroupBy
  ) {
    processingsClosedCountByProcessingTypeResult(
      categoryName: $categoryName
      filter: $filter
      groupBy: $groupBy
    ) {
      series {
        color
        title
        usersAverage
        processingTypeAverage
        serie {
          name
          date
          count
        }
      }
    }
  }
`
